import { useEffect, useRef } from "react";

/**
 * TrafficJunky-konverteringspixel.
 *
 * Fyrer kun én gang per session — leser cookien `tj_fire` (satt av backend
 * etter vellykket registrering), poster pixelen til ads.trafficjunky.net
 * og sletter cookien umiddelbart slik at refresh / innlogging ikke gjenfyrer.
 *
 * Pixelen er en 1x1 IMG som lastes i bakgrunnen — ingen synlig DOM.
 */
const TJ_AD_ID = "1000574681";
const TJ_MEMBER_ID = "1008947371";

function getCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

function deleteCookie(name) {
  // Slett samme cookie-attributter som backend satt (path, secure, samesite)
  document.cookie = `${name}=; Max-Age=0; path=/; secure; samesite=none`;
}

export default function TJConversionPixel() {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    const userId = getCookie("tj_fire");
    if (!userId) return;
    fired.current = true;
    // Slett cookien FØR pixelen lastes, slik at en samtidig retry/HMR ikke
    // får fyrt en gang til.
    deleteCookie("tj_fire");

    const cb = Math.floor(Math.random() * 1e10);
    const url =
      `https://ads.trafficjunky.net/ct?a=${TJ_AD_ID}` +
      `&member_id=${TJ_MEMBER_ID}` +
      `&cb=${cb}` +
      `&cti=${encodeURIComponent(userId)}` +
      `&ctv=0.00` +
      `&ctd=${encodeURIComponent("signup")}`;

    const img = new Image(1, 1);
    img.referrerPolicy = "no-referrer-when-downgrade";
    img.src = url;
    // Ikke append til DOM — Image() utløser request alene.
  }, []);

  return null;
}
